import React, { type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useActionsCommandPalette } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useCommandPaletteFeedbackCollector } from '../../controllers/use-feedback-collector/index.tsx';
import { messages } from '../../controllers/use-feedback-collector/messages.tsx';

export const FooterFeedbackContent = () => {
	const [openFeedbackCollectorDialog] = useCommandPaletteFeedbackCollector();

	const { close } = useActionsCommandPalette();

	const { formatMessage } = useIntl();

	return (
		<FeedbackContentWrapper>
			<TextWrapper> {formatMessage(messages.feedbackContentText)} </TextWrapper>
			<FeedbackButton
				appearance="subtle-link"
				testId="command-palette-integration.ui.footer-feedback-content.feedback-button"
				onClick={(event: SyntheticEvent<unknown>, analyticsEvent: UIAnalyticsEvent) => {
					close();
					fireUIAnalytics(analyticsEvent, 'openCommandPaletteFeedbackForm');
					openFeedbackCollectorDialog();
				}}
			>
				{formatMessage(messages.feedbackButtonText)}
			</FeedbackButton>
		</FeedbackContentWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FeedbackContentWrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',

	font: token('font.body.UNSAFE_small'),
	padding: `0 ${token('space.100', '8px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: `${token('color.text.subtle', colors.N400)}`,
	justifyContent: 'flex-start',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'button span': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		color: `${token('color.text.subtle', colors.N400)}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextWrapper = styled.div({
	font: token('font.body.UNSAFE_small'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N400),
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FeedbackButton = styled(Button)({
	font: token('font.body.UNSAFE_small'),
	alignItems: 'center',
	fontWeight: token('font.weight.medium'),
	marginLeft: token('space.025', '2px'),
	padding: `0 ${token('space.025', '2px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: `${token('color.text.subtle', colors.N400)} !important`,
	height: 'auto',
	lineHeight: 'initial',
});
